import {ObjectLiteral} from "typeorm/browser/common/ObjectLiteral";
import {FindManyOptions} from "typeorm/browser/find-options/FindManyOptions";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {DeepPartial} from "typeorm/browser/common/DeepPartial";
import {SaveOptions} from "typeorm/browser/repository/SaveOptions";
import { FindOneOptions} from "typeorm/browser";
import {IRepository} from "./IRepository";
import {Grupo} from "../../domain/enums";

@Injectable({providedIn: 'root'})
export class HttpRepository<Entity extends ObjectLiteral> implements IRepository<Entity> {

  constructor(private http: HttpClient) {
  }



  find(options?: FindManyOptions<Entity>): Promise<Entity[]> {
    throw Error("não implementado")
  }

  findAndCount(options?: FindManyOptions<Entity>): Promise<[Entity[], number]> {
    throw Error("não implementado")
  }

  findTaxon(grupos: Grupo[], texto: string): Promise<Entity[]> {
    throw Error("não implementado")
  }

  // findOneByOrFail(where: FindOptionsWhere<Entity> | FindOptionsWhere<Entity>[]): Promise<Entity> {
  //   throw Error("não implementado")
  // }
  //
  // findOneBy(where: FindOptionsWhere<Entity> | FindOptionsWhere<Entity>[]): Promise<Entity | null>{
  //   throw Error("não implementado")
  // }

  findOne(options: FindOneOptions<Entity>): Promise<Entity> {
    throw Error("não implementado")
  }


  findOneOrFail(options: FindOneOptions<Entity>): Promise<Entity> {
    throw Error("não implementado")
  }

  // findTrees(options?: FindTreeOptions): Promise<Entity[]> {
  //   return Promise.resolve([]);
  // }

  save<T extends DeepPartial<Entity>>(entity: T, options?: SaveOptions): Promise<T & Entity> {
    throw Error("não implementado")
  }

  delete<T extends DeepPartial<Entity>>(t: T): Promise<T> {
    throw Error("não implementado")
  }
}
